const useInput = ({
  setPage,
  setCover,
  setAvatar,
  setLinkStyle,
  setLinks,
  setScripts,
  page,
  linkStyle,
  links,
  scripts,
}) => {
  const handlePageChange = (event) => {
    const { name, value } = event.target;
    setPage({ ...page, [name]: value });
  };

  const handleCoverChange = (event) => {
    setCover(event.target.files[0]);
  };

  const handleAvatarChange = (event) => {
    setAvatar(event.target.files[0]);
  };

  const handleLinkStyleChange = (event) => {
    const { name, value } = event.target;
    setLinkStyle({ ...linkStyle, [name]: value });
  };

  const handleLinkChange = (event) => {
    const { name, value } = event.target;
    setLinks({ ...links, [name]: value });
  };

  const handleScriptChange = (event) => {
    const { name, value } = event.target;
    setScripts({ ...scripts, [name]: value });
  };

  return {
    handlePageChange,
    handleCoverChange,
    handleAvatarChange,
    handleLinkStyleChange,
    handleLinkChange,
    handleScriptChange,
  };
};

export default useInput;
